import { useAppSelector } from "../hooks/useSelector";

interface PermissionProps {
  is_read?: boolean;
  is_create?: boolean;
  is_update?: boolean;
  is_delete?: boolean;
}

interface Props {
  children: any;
  small?: boolean;
  requiredPermissions: PermissionProps; // Required permissions for this page
  menuSlug: string; // Slug of the menu item to match
}

export default function ProtectedPermissionView(props: Props) {
  const { children, menuSlug, requiredPermissions } = props;
  const { menu } = useAppSelector((state) => state.global);
  const menuItem = menu.find(
    (menu: { slug: string }) => menu.slug === menuSlug
  );

  // Check if user has the required permissions for this page
  const hasMenuPermission = menuItem
    ? Object.keys(requiredPermissions).every((key) => {
        return (
          requiredPermissions[key as keyof PermissionProps] === false ||
          menuItem[key as keyof PermissionProps]
        );
      })
    : false;
  if (!hasMenuPermission) {
    return null;
  }

  return children;
}
